import { IProduct } from './i-product';

export class TagManagerProductDto implements IProduct {
  id = 'N/A';

  name = 'N/A';

  price = 0;

  brand = 'N/A';

  category = 'N/A';

  variant = 'N/A';

  quantity = 1;

  dimension5 = 'N/A';

  dimension9 = 'N/A';

  dimension13 = 0;

  dimension14 = 0;
}
